export const ListQueryKey = 'boatConfigs';
export const DetailQueryKey = 'boatConfig';

export const Urls = {
  selectUrl: '/boatRewardConfig/list',
  updateUrl: '/boatRewardConfig/update',
  deleteUrl: '/boatRewardConfig/delete',
  createUrl: '/boatRewardConfig/create',
  detailUrl: '/boatRewardConfig/detail',
};
